import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class FileUpload  {
    _originalTypeClassName = "zERP.BO.FileUpload";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
FileUpload.translate = translateService;
}
this.File = new Domain.FileData();
this.Id = null;
this.Notes = null;
this.Entity = null;
this.EntityId = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Notes:any;
Entity:any;
EntityId:any;
File:any;
static setFile = ($this, value) => {
var oldValue = $this.File;
$this.File = value;
if (value != null) {
}
}

static CreateDraft(entity: any,entityId: any): any{let fileUpload = new Domain.FileUpload();
fileUpload.Entity = entity;
fileUpload.EntityId = entityId;
return fileUpload;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}